import { toast } from "react-toastify";
import { finalizePayrollRun } from "features/Payroll/services/PayrollService";

export async function finalizePayrollRunWithFeedback(
  runId: number,
): Promise<{ ok: boolean; message: string }> {
  try {
    const res = await finalizePayrollRun(runId);
    if (res.success) {
      return { ok: true, message: res.message || "Payroll run finalized" };
    }
    toast.error(res.message || "Could not finalize run");
    return { ok: false, message: "" };
  } catch (err: unknown) {
    const msg = (err as { response?: { data?: { message?: string } } })
      ?.response?.data?.message;
    toast.error(msg || "Could not finalize run");
    return { ok: false, message: "" };
  }
}
